import TokenService from "./token.service";
import {Store} from "vuex";
import instance from "./fetch";
import router from '../router'

const setupInterceptors = (store: Store<any>) => {
    instance.interceptors.response.use(
        response => {
            return response
        },
        error => {
            if (!error.response) {

                //console.log("Please check your internet connection.");
                router.push({name: 'login'})
            }

            return Promise.reject(error)
        }
    )
    instance.interceptors.request.use(
        (config) => {
            const token = TokenService.getLocalAccessToken();
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token;
            }
            return config;
        },
        (error: string) => {
            router.push({name: 'login'})
            return Promise.reject(error);
        }
    );

    instance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            if (originalConfig.url !== "auth/login/" && err.response) {
                // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        instance.post("token/refresh/", {
                            refresh: localStorage.getItem("refresh"),
                        }).then(res => {
                            if (res.status === 200) {
                                TokenService.updateLocalAccessToken(res.data.access, res.data.refresh);
                                return instance(originalConfig);
                            }
                        }).catch(err => {
                            localStorage.removeItem("refresh");
                            localStorage.removeItem("token");
                            router.push({name: 'login'})
                        })
                    } catch (_error) {

                        return Promise.reject(_error);
                    }
                }
            }

        }
    );
};

export default setupInterceptors;
